import React from "react";

function LendingSoftware() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                P2P Lending Software Development with Xeer Technology
              </h2>
              <p>
                Peer-to-peer lending platforms are transforming the financial
                ecosystem by offering direct, decentralized lending options. At
                Xeer Technology, we specialize in custom P2P lending software
                development, enabling seamless lending experiences backed by
                blockchain’s transparency, security, and efficiency.
              </p>
              {/* <p>
                With our ready-made solution, you can quickly launch your own
                branded wallet, tailored to meet the needs of your customers
                while saving valuable development time and costs. Whether you're
                looking to improve customer loyalty, expand your service
                offerings, or tap into new revenue streams, our White Label
                Crypto Wallet is designed to help you succeed.
              </p> */}
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LendingSoftware;
